@let registrationNumbers = data?.airlineConfirmations; @let bookingHotel = data?.bookingHotel;

<div class="booking-hotel">
  <div class="d-flex flex-column booking-hotel-header">
    <div class="d-flex align-items-center booking-hotel-header-title">
      <ds-button (click)="goBack()" variant="icon" icon="chevronLeft" label="Back" data-id="back" />
      <h1 class="semi-bold">{{ data?.bookingHotel?.name }}</h1>
      <ds-chip [title]="'Booking: ' + data?.portalLink" />
    </div>

    @if (registrationNumbers?.length) {
      <div class="d-flex flex-column g-2">
        @for (registrationNumber of registrationNumbers; track registrationNumber) {
          <div class="d-flex booking-hotel-header-subtitle">
            <div class="d-flex align-items-center g-2">
              <p class="booking-hotel-header-subtitle-text">Confirmation number:</p>
              <p class="booking-hotel-header-subtitle-text" data-id="confirmation-title">
                {{ registrationNumber.airline?.shortName }}
              </p>

              <div
                [copyToClipboard]="registrationNumber.code"
                data-id="copy"
                class="d-flex align-items-center g-2 cursor-pointer"
              >
                <p
                  class="booking-hotel-header-subtitle-text semi-bold"
                  data-id="confirmation-number"
                >
                  {{ registrationNumber.code }}
                </p>
                <img
                  class="booking-hotel-header-subtitle-img"
                  src="assets/icons/copy_icon.svg"
                  alt="copy"
                />
              </div>
            </div>

            @if (false) {
              <!--    Add after backend changes-->
              <a [href]="''" target="_blank" class="cursor-pointer link" data-id="airline-website">
                <div class="d-flex align-items-center g-2">
                  <p class="semi-bold text-lightblue-600 booking-hotel-header-subtitle-text">
                    Go to hotel's website
                  </p>
                  <img
                    class="booking-hotel-header-subtitle-img"
                    src="assets/icons/arrow_outward.svg"
                    alt="arrow outward"
                  />
                </div>
              </a>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (bookingHotel) {
    <booking-hotel-card class="booking-hotel-card" [isClickable]="false" [data]="bookingHotel" />
  }
  @if (false) {
    <!--      Add after backend changes (TIC-5528)-->
    <div class="w-100">
      <h2 class="semi-bold booking-hotel-guests-title">Guests</h2>
      <div class="g-4 d-flex flex-column booking-hotel-guests-container">
        <traveler-info [fields]="guestFields" />
      </div>
    </div>
  }
</div>
